import * as XLSX from "xlsx";

export function getFileSizeString(size: number): string | undefined {
  if (size < 1024) return size + "B";
  size /= 1024;
  size = parseFloat(size.toFixed(2));
  if (size < 1024) return size + "KB";
  size /= 1024;
  size = parseFloat(size.toFixed(2));
  if (size < 1024) return size + "MB";
  size /= 1024;
  size = parseFloat(size.toFixed(2));
  if (size < 1024) return size + "GB";
  size /= 1024;
  size = parseFloat(size.toFixed(2));
  if (size < 1024) return size + "TB";
}

export function getShortFilename(filename: string, maxLength: number = 10): string {
  let shortenedFilename = filename;
  if (filename.length > maxLength) {
    const start = filename.substr(0, maxLength / 2 - 1);
    const end = filename.substr(-maxLength / 2 + 2);
    shortenedFilename = start + "..." + end;
  }
  return shortenedFilename;
}

export async function isEncryptedExcel(file: File): Promise<boolean> {
  const data = await file.arrayBuffer();
  const header = new Uint8Array(data.slice(0, 4));
  const isCFB =
    header[0] === 0xd0 &&
    header[1] === 0xcf &&
    header[2] === 0x11 &&
    header[3] === 0xe0;

  // .xlsx: 정상이면 ZIP(PK) 헤더, 암호화되면 CFB 헤더
  if (file.name.toLowerCase().endsWith(".xlsx") && isCFB) {
    return true;
  }

  // .xls: SheetJS 파싱 시도로 판별
  try {
    XLSX.read(data);
    return false;
  } catch {
    return true;
  }
}
